import React from "react";
import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { useFetchGoogleFreeBookingLinksSettingsI18n } from "../api";
import { FormGoogleFreeBookingLinksIslandSettingsI18n } from "./settings";

type Props = {
	hotelID: string;
	langCode: LangCode;
};

export const GoogleFreeBookingLinksSettingsI18n: React.FC<Props> = ({ hotelID, langCode }) => {
	const { data } = useFetchGoogleFreeBookingLinksSettingsI18n({ hotelID, langCode });

	if (!data) {
		return (
			<Navigate
				to={generatePath(PATHS.SETTINGS.EXTERNAL_CONNECTION.GOOGLE_FREE_BOOKING_LINKS.DEFAULT, { hotelID })}
			/>
		);
	}

	return <FormGoogleFreeBookingLinksIslandSettingsI18n googleFreeBookingLinksSettingsI18nQueryData={data} />;
};
